// todo: original idea was to create a more dynamic form capture dialog, so that it could be used for this, the InviteDialog and others that capture information. If that form is optional, it can also replace the YesNoDialog

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import NumberFormat from 'react-number-format';

const AcceptInviteDialog = (props) => {
   const initialState = {
      postalCode: '',
   };
   const [formValues, setFormValues] = useState(initialState);

   // validation
   const [formValidation, setFormValidation] = useState({});
   const formIsValid = () => {
      let errors = {};

      if ((formValues.postalCode && formValues.postalCode.toString().length !== 5) || !formValues.postalCode)
         errors.postalCode = 'Zip Code invalid.';

      setFormValidation(errors);

      return Object.keys(errors).length === 0;
   };

   const handlePostalCodeChange = (value) => {
      setFormValues({ ...formValues, postalCode: value.value });
   };

   const handleAcceptInviteButtonClick = () => {
      if (formIsValid()) {
         props.handleAffirm(formValues);
         setFormValues({ ...initialState });
      }
   };

   return (
      <Dialog
         open={props.open}
         onClose={props.handleDismiss}
         aria-labelledby="yes-no-dialog-title"
         aria-describedby="yes-no-dialog-description"
      >
         <DialogTitle id="yes-no-dialog-title">
            {props.title}
         </DialogTitle>
         <DialogContent>
            <DialogContentText id="yes-no-dialog-description">
               {props.description}
            </DialogContentText>
            <DialogContentText>
               <p>To accept the invite, provide the zip code of the person who invited you. This step helps to confirm that you know them.</p>
            </DialogContentText>
         </DialogContent>
         <DialogContent>
            <Box component="form">
               <Grid container spacing={1}>
                  <Grid item xs={12}>
                     <FormControl fullWidth>
                        <NumberFormat
                           autoFocus
                           customInput={TextField}
                           format="#####"
                           isNumericString={true}
                           mask="_"
                           margin="dense"
                           id="postal-code-input"
                           label={`Zip Code${props.isRequired ? '*' : ''}`}
                           type="text"
                           value={formValues.postalCode}
                           onValueChange={(value) => handlePostalCodeChange(value)}
                           error={formValidation.postalCode ? true : false}
                           helperText={formValidation.postalCode}
                           fullWidth
                        />
                     </FormControl>
                  </Grid>
               </Grid>
            </Box>
         </DialogContent>
         <DialogActions>
            <Button variant="outlined" startIcon={<CancelIcon />} onClick={props.handleDismiss}>{props.dismissButtonLabel}</Button>
            <Button variant="contained" startIcon={<CheckIcon />} onClick={handleAcceptInviteButtonClick} autoFocus>{props.affirmButtonLabel}</Button>
         </DialogActions>
      </Dialog>
   );
};

AcceptInviteDialog.propTypes = {
   open: PropTypes.bool.isRequired,
   title: PropTypes.string.isRequired,
   description: PropTypes.string.isRequired,
   dismissButtonLabel: PropTypes.string.isRequired,
   affirmButtonLabel: PropTypes.string.isRequired,
   handleDismiss: PropTypes.func.isRequired,
   handleAffirm: PropTypes.func.isRequired,
};

export default AcceptInviteDialog;
